<template>
  <section id="conventionalShipment" class="page-content">
    <main id="section-body">
      <div class="columns is-variable is-8">
        <div class="shipment-detail column">
          <shipment-conventional-card :shipment="trackingRequest" />
          <div class="shipment-detail" style="margin-top: 2.5em;" v-if="trackingRequest.devices">
            <div class="card">
              <div class="card-content">
                <div style="display: flex; justify-content: space-between;">
                  <div class="subtitle"><i class="fas fa-globe-americas"></i> Tracking Devices</div>
                  <button class="button is-small is-success" @click="showModalDevices=true">add devices</button>
                </div>
                <div v-for="device in devices" :key="device.device_id">
                  <div class="content"> <strong>Device: </strong> {{ device.device_id }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="shipment-detail column is-four-fifths">
          <div style="display: flex;">
          <div class="card level" >
            <div class="level-item has-text-centered">
              <div>
                <span class="ico" style="background: #1ca7d1"><icon icoClass='event-ico' selected='anchor'/></span>
                <table>
                  <tr v-if="trackingRequest.pod && trackingRequest.pod.port">
                    <td class="bold-title"  style="padding:0 3px">
                      {{trackingRequest.pod.port.locode}},
                    </td>
                  </tr>
                  <tr v-if="trackingRequest.pol && trackingRequest.pol.port">
                    <td class="bold-title"  style="padding:0 3px">
                      {{trackingRequest.pol.port.locode}}
                    </td>
                  </tr>
                </table>
              </div>
            </div>
            <div class="level-item has-text-centered">
              <div>
                <a :href="map_url" target="_blank">
                  <span class="ico" style="background: #C03044"><icon icoClass='event-ico' selected='location'/></span>
                  <span class="bold-title" v-if="last_coordinates.lat">lat: {{last_coordinates.lat}}</span>
                  <span class="bold-title" v-if="last_coordinates.lng">lng: {{last_coordinates.lng}}</span>
                </a>
              </div>
            </div>
            <div class="level-item has-text-centered">
              <div>
                <span class="ico" style="background: #E07020"><icon icoClass='event-ico' selected='date'/></span>
                <span class="bold-title">
                  <table>
                    <tr><td>ETA: {{trackingRequest.eta | toString}}</td></tr>
                  </table>
                </span>
              </div>
            </div>
            <div class="level-item has-text-centered">
              <div>
                <span class="ico" style="background: #1c1761"><icon icoClass='event-ico' selected='shipments'/></span>
                <table><tr>
                  <td class="bold-title" style="padding:0 3px" v-if="trackingRequest.conventional_shipment && trackingRequest.conventional_shipment.id > 0 && trackingRequest.conventional_shipment.vessel">
                    {{trackingRequest.conventional_shipment.vessel.imo + ' - ' + trackingRequest.conventional_shipment.vessel.name}}
                  </td>
                  <td class="bold-title" style="padding:0 3px" v-else>
                    {{trackingRequest.vessel_imo}}
                  </td>
                </tr></table>
              </div>
            </div>
          </div>
          <div class="warning" v-if="trackingRequest.conventional_shipment && trackingRequest.conventional_shipment.id == 0">
            <icon icoClass="event-ico" selected="danger" />
            <span><strong style="color: white">Warning!</strong> No shipment associated with this tracking</span>
          </div>
        </div>
          <div>
            <shipment-conventional-status-calendar :shipment="trackingRequest"/>
            <shipment-conventional-map :shipment="trackingRequest.conventional_shipment" :devices="devicesPosition" v-if="trackingRequest.conventional_shipment && trackingRequest.conventional_shipment.id > 0"/>
            <a @click="back" class="button" style="margin-top: 2em">Back</a>
          </div>
        </div>
      </div>
      <devices-modal v-if="showModalDevices" @close="showModalDevices=false" @change="getDevices(trackingRequest.id)" :object="trackingRequest" />
    </main>
  </section>
</template>

<script>
import {mapActions} from 'vuex'
import icon from './../../svg/events.vue'
import ShipmentConventionalCard from '../../components/conventional/ShipmentConventionalCard.vue'
import ShipmentConventionalMap from '@/components/conventional/ShipmentConventionalMap.vue'
import ShipmentConventionalStatusCalendar from '@/components/conventional/StatusCalendarConventionalShipment.vue'
import moment from 'moment'
import DevicesModal from '@/components/DevicesModal'

export default {
  name: 'conventional-shipment',
  components: {ShipmentConventionalCard, ShipmentConventionalStatusCalendar, ShipmentConventionalMap, icon, DevicesModal},
  mounted () {
    this.$emit('loading')
    this.get(this.$route.params.id).then(
      response => {
        this.trackingRequest = response
        this.$emit('loaded')
      }
    )
    this.getDevices(this.$route.params.id)
  },
  data () {
    return {
      trackingRequest: {},
      devices: [],
      devicesPosition: [],
      stages: [],
      showModalDevices: false,
      last_coordinates: {}
    }
  },
  filters: {
    toString: function (value) {
      if (value instanceof Date && !isNaN(value.valueOf())) {
        let dateString = moment(value).format('YYYY-MM-DD')
        return dateString
      }
      if (typeof (value) === 'object' && value) {
        return value.__str__
      }
      if (value) {
        return value.toString()
      }
      return ''
    }
  },
  computed: {
    map_url () {
      if (this.trackingRequest['conventional_shipment'] && this.trackingRequest['conventional_shipment']['current_position']) {
        this.last_coordinates = { lat: this.trackingRequest['conventional_shipment']['current_position'].lat, lng: this.trackingRequest['conventional_shipment']['current_position'].lng }
        var lastCoord = this.trackingRequest['conventional_shipment']['current_position'].lat + ', ' + this.trackingRequest['conventional_shipment']['current_position'].lng
        return `https://maps.google.com/?q=${lastCoord}&ll=${lastCoord}&z=5`
      }
      return null
    },
    ports_involved () {
      const portFields = ['pol', 'tsp', 'pod']
      let ports = []

      portFields.forEach(field => {
        if (this.shipment[`${field}_loc`] && this.shipment[`${field}_loc`].__str__) {
          ports.push(this.shipment[`${field}_loc`].__str__)
        }
      })
      ports = [ports.slice(0, ports.length / 2 + ports.length % 2), ports.slice(ports.length / 2 + ports.length % 2)]
      return ports
    }
  },
  methods: {
    back () {
      this.$router.go(-1)
    },
    ...mapActions({
      get: 'conventionalTrackingRequest/retrieve',
      getDevs: 'device/list'
    }),
    getDevices (obj) {
      this.getDevs({id: obj}).then((response) => {
        this.devices = response
        this.devicesPosition = this.devices.filter((x) => x.current_position != null)
      })
    }
  }
}
</script>


<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';

  #shipment #section-header {
    margin: 0;
    color: white;
    background: rgb(58, 63, 81);
    padding-left: 0;
    padding-right: 0;
    position: relative;
    top: 0;
    .title {
      color: white;
    }
  }
  .columns.is-variable.is-8 {
    --columnGap: 1rem;
  }
  .shipment-detail.column {
    padding-left: .5em;
    padding-right: .5em;
  }
  #shipment #section-body{
    padding-top: 30px;
  }
  ul.timeline, ul.timeline ul {
    list-style: disc;
    margin-left: 20px;
  }
  .ico {
    display: inline-block;
    border-radius: 50%;
    padding: 5px;
    margin: 10px;
  }
  .level {
    display: inline-block;
    padding: 1em;
  }
  .level-item {
    display: inline-block;
    font-size: 1.1em;
    padding: 0 1em;
  }
  table {
    display: inline-block;
    vertical-align: middle;
  }
  .warning {
    border-left: 6px solid $danger-dark;
    margin-left: 1em;
    width: 50%;
    color: #fff !important;
    background-color: $danger !important;
    font-size: 1.5em;
    line-height: 2em;
    padding: 1em;
    box-shadow: 0 2px 3px rgba(51, 51, 51, 0.1), 0 0 0 1px rgba(51, 51, 51, 0.1);
    margin-bottom: 1.5rem;
    span {
      margin-left: 10px;
    }

  }
</style>



// WEBPACK FOOTER //
// src/pages/conventional/PageShipmentConventional.vue